import { render, staticRenderFns } from "./DemonstrativoLerComanda.vue?vue&type=template&id=19b34047&scoped=true&"
import script from "./DemonstrativoLerComanda.vue?vue&type=script&lang=js&"
export * from "./DemonstrativoLerComanda.vue?vue&type=script&lang=js&"
import style0 from "./DemonstrativoLerComanda.vue?vue&type=style&index=0&id=19b34047&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b34047",
  null
  
)

export default component.exports